import styled, { css } from "styled-components";
import { ColorAddiFontOverDark, ColorAddiBackgroundStrong, ColorAddiFontStrong, ColorAddiBackgroundSoft, ColorAddiFeedbackSuccess, ColorAddiPrimaryActive } from '@addi/foundation/dist/web/colors';
import { SizeAddiFontSmall, SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
import { FontAddiWeightExtraBold } from '@addi/foundation/dist/web/fonts';
import { Caption } from '../../components/typographies';
import { StepState } from "./stepper.prop-types";
import { Icon } from "../styled-icon";
export var STEP_SIZE;
(function (STEP_SIZE) {
    STEP_SIZE[STEP_SIZE["NORMAL"] = 20] = "NORMAL";
    STEP_SIZE[STEP_SIZE["BIG"] = 50] = "BIG";
})(STEP_SIZE || (STEP_SIZE = {}));
;
export const StepperContainer = styled.div `
    max-width: 100%;
    min-height: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
`;
export const StepContainer = styled.div `
    z-index: 2;
    width: ${STEP_SIZE.NORMAL}px;
    height: ${STEP_SIZE.NORMAL}px;
    background: ${ColorAddiBackgroundSoft};
    text-align: center;
    color: ${ColorAddiFontStrong};
    border-radius: 50%;

    ${Caption} {
        font-size: ${SizeAddiFontSmall};
        font-style: normal;
        font-weight: ${FontAddiWeightExtraBold};
        line-height: 21px;
        letter-spacing: 0px;
        text-align: left;
        color: ${ColorAddiFontStrong};
    }

    ${Icon} {
        font-size: ${SizeAddiFontXSmall};
        line-height: 12px;
        margin-top: 3px;
    }

    ${props => props.state === StepState.ACTIVE && css `
        width: ${STEP_SIZE.NORMAL}px;
        height: ${STEP_SIZE.NORMAL}px;
        background-color: ${ColorAddiPrimaryActive};
        color: ${ColorAddiFontOverDark};
        border: 2px solid ${ColorAddiPrimaryActive};
        ${Caption} {
            color: ${ColorAddiFontOverDark};
        }
    `};

    ${props => props.state === StepState.DONE && css `
        width: ${STEP_SIZE.NORMAL}px;
        height: ${STEP_SIZE.NORMAL}px;
        background-color: ${ColorAddiFeedbackSuccess};
        color: ${ColorAddiFontOverDark};
    `};
`;
export const Progress = styled.div `
    flex-grow: 1;
    position: relative;
    min-height: 2px;
    background: ${ColorAddiBackgroundSoft};

    &::before {
        content: '';
        background: ${ColorAddiBackgroundStrong};
        position: absolute;
        height: 2px;
        z-index: 1;
        transition-property: width;
        transition-duration: 0.05s;
        transition-timing-function: ease-in-out;
        width: ${props => props.state != null && props.index != null && props.state > props.index ? '100%' : '0'};
    }
`;
//# sourceMappingURL=Stepper.Styled.js.map